export default __webpack_public_path__ + "static/media/ProfilePic.70d35166.jpg";